"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp(target, key, result);
  return result;
};
import { LitElement, html } from "lit";
import { property, query, state } from "lit/decorators.js";
import { STCComponentMixin } from "../../../common/mixins/stc_component_mixin";
import { QuickSearchController } from "./controllers/quick_search_controller";
export class StcQuickSearch extends STCComponentMixin(LitElement) {
  constructor() {
    super(...arguments);
    this.emptyMessage = "";
    this.placeholderMessage = "";
    this.isCommandOrCtrlOn = false;
    this.quickSearchController = new QuickSearchController(this);
  }
  getResults(searchTerm) {
    return this.quickSearchController.fetchResults(
      this.quickSearchUrl,
      searchTerm,
      this.getHeaders()
    );
  }
  getHeaders() {
    return {
      "X-CSRF-Token": this.formAuthenticityToken,
      "X-Requested-With": "XMLHttpRequest"
    };
  }
  handleMouseUp(e) {
    this.isCommandOrCtrlOn = e.metaKey || e.ctrlKey;
  }
  handleCommitEnded(e) {
    const href = e.detail.value.value;
    if (this.isCommandOrCtrlOn) {
      window.open(href, "_blank");
    } else {
      location.assign(href);
    }
    this.isCommandOrCtrlOn = false;
  }
  handleSearchValueChanged(e) {
    this.getResults(e.detail.value).then((results) => {
      if (results === void 0) return;
      this.searchResults = results;
    });
  }
  shouldHideStatusMessage() {
    if (this.searchResults === void 0) return true;
    return this.searchResults.length > 0;
  }
  render() {
    return html`
      <hi-search
        id="top-nav__quick-search"
        @commit-ended=${this.handleCommitEnded}
        @search-value-changed=${this.handleSearchValueChanged}
        @mouseup=${this.handleMouseUp}
        class="top-nav__quick-search"
        aria-label="quick search"
        .input=${this.searchResults}
        kind="dynamic"
        hidden-result-message
        ?hidden-status-message=${this.shouldHideStatusMessage()}
        placeholder=${this.placeholderMessage}
      >
        <p slot="empty-message" class="text-light">
          ${this.emptyMessage}
        </p>
      </hi-search>
    `;
  }
}
__decorateClass([
  property({ type: Boolean })
], StcQuickSearch.prototype, "ignoreGroups", 2);
__decorateClass([
  property({ type: String })
], StcQuickSearch.prototype, "quickSearchUrl", 2);
__decorateClass([
  property({ type: String })
], StcQuickSearch.prototype, "formAuthenticityToken", 2);
__decorateClass([
  property({ type: Array })
], StcQuickSearch.prototype, "searchResults", 2);
__decorateClass([
  property({ type: String, attribute: "empty-message" })
], StcQuickSearch.prototype, "emptyMessage", 2);
__decorateClass([
  property({ type: String, attribute: "placeholder-message" })
], StcQuickSearch.prototype, "placeholderMessage", 2);
__decorateClass([
  state()
], StcQuickSearch.prototype, "abortController", 2);
__decorateClass([
  query("#top-nav__quick-search")
], StcQuickSearch.prototype, "quickSearchElement", 2);
customElements.define("stc-quick-search", StcQuickSearch);
